import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const rotationMap = {
  left: 0,
  up: 90,
  right: 180,
  down: 270
};
export const ArrowHead = _ref => {
  let {
    direction
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "rotate(".concat(rotationMap[direction], "deg)")
    },
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 11.9999C8.49846 11.7341 8.60281 11.4787 8.79 11.2899L12.79 7.28994C13.1821 6.89782 13.8179 6.89782 14.21 7.28994C14.6021 7.68206 14.6021 8.31782 14.21 8.70994L10.9 11.9999L14.08 15.2999H14.08C14.4906 15.6692 14.5242 16.3015 14.1549 16.7122C13.7855 17.1228 13.1533 17.1563 12.7426 16.787C12.7058 16.7539 12.6715 16.7181 12.64 16.6799L8.78 12.6799C8.60368 12.4971 8.50357 12.2539 8.5 11.9999L8.5 11.9999Z",
      fill: "currentColor"
    })
  });
};